import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../services/http/http.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    ReactiveFormsModule
  ],
  standalone: true
})
export class NotificationDialogComponent {

  title : string;
  message : string;


  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public config: {title : string, message : string},
  ) {
    this.title = config.title;
    this.message = config.message;
  }


  onClose() : void {
    this.dialogRef.close();
  }
}
